var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityLabel } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { AppDialog } from '../app/app-dialog';
import { useDialogs } from '../hooks/use-dialogs';
import { usePageEntity } from '../hooks/use-page-entity';
import { Form } from '../elements/form';
import { first, values } from 'lodash';
import { useEntityForm } from '../hooks/use-entity-form';
import { AppDialogLoader } from '../app/app-dialog-loader';
var cls = classNames('slice-edit-dialog');
export var SliceEditDialogDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    top: 2vh;\n    width: 96vw;\n    margin: 0 auto;\n    ", "\n  "], ["\n    position: relative;\n    top: 2vh;\n    width: 96vw;\n    margin: 0 auto;\n    ", "\n  "])), function (_a) {
    var fillHorizontal = _a.fillHorizontal;
    return !fillHorizontal && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      max-width: 950px;\n    "], ["\n      max-width: 950px;\n    "])));
  }),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 90vw;\n    top: 5vh;\n  "], ["\n    width: 90vw;\n    top: 5vh;\n  "])))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FormStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    overflow-y: auto;\n    max-height: calc(90vh - 55px - 60px);\n    box-sizing: border-box;\n    ", "\n  "], ["\n    overflow-y: auto;\n    max-height: calc(90vh - 55px - 60px);\n    box-sizing: border-box;\n    ", "\n  "])), function (_a) {
    var isChromeless = _a.isChromeless;
    return !isChromeless && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme.UNIT(5));
  })
});
// -------- Components -------->
var My = {
  NAME: 'SliceEditDialog',
  Container: styled(AppDialog)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Form: styled(Form)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  Loader: styled(AppDialogLoader)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles)
};
export var SliceEditDialog = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, SliceEditDialogDefaultProps, props);
  var className = componentProps.className,
    entity = componentProps.entity;
  var dialogs = useDialogs();
  var pageEntity = usePageEntity();
  var typeLabel = entityLabel(pageEntity);
  var form = useEntityForm({
    type: 'Update',
    entity: pageEntity,
    fields: entity.entityFormFields
  });
  // switch to a "chromeless" version of the form if there is just one junction field
  var isSingleJunction = form.fields.length === 1 && form.fields[0].type === 'linkedJunction';
  var isChromeless = isSingleJunction; //isSingleJunction;
  // single junction table forms shouldn't need a save / cancel control set, as all CRUD is done within the Grid UI 
  var canSave = !isChromeless;
  // when we are in a single junction form, we want to show a custom add button in the dialog controls
  var firstSupportingDefn = first(values(form.supportingEntityTypeDefinitions));
  var endActions = canSave ? ['cancel', 'save'] : ['done'];
  // const startActions: AppButtonAction[] = (form.isReady && isSingleJunction) ? ['add'] : [];
  var buttonLabels = firstSupportingDefn ? {
    add: firstSupportingDefn.createLabel
  } : undefined;
  var closeAction = canSave ? 'close' : 'done';
  var onButtonAction = function (action) {
    return __awaiter(void 0, void 0, void 0, function () {
      var result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (action === 'cancel' || action === 'done') {
              dialogs.pop();
            }
            if (!(action === 'save')) return [3 /*break*/, 2];
            return [4 /*yield*/, form.submit()];
          case 1:
            result = _a.sent();
            if (result.data) {
              dialogs.pop();
            }
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };
  return React.createElement(My.Container, {
    fillHorizontal: isSingleJunction,
    fillVertical: false,
    action: "edit",
    buttonLabels: buttonLabels,
    subject: ((_a = entity.label) === null || _a === void 0 ? void 0 : _a.replace(/:/g, '')) || typeLabel,
    onButtonAction: onButtonAction,
    closeAction: closeAction,
    disabledActions: form.disabledActions,
    loadingActions: form.loadingActions,
    endActions: endActions,
    onCloseClick: function () {
      dialogs.pop();
    },
    className: cls.name(className)
  }, !form.isReady ? React.createElement(My.Loader, {
    spinnerColor: 'strong-chrome',
    spinnerSize: 18
  }) : React.createElement(My.Form, {
    isChromeless: isChromeless,
    disabled: form.isSubmitting,
    fields: form.fields,
    name: form.name,
    onSubmit: function (result) {
      onButtonAction('save', result.event);
    }
  }));
};
SliceEditDialog.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;